const { v4 } = require("uuid")

const CSP_NONCE = v4()

export default CSP_NONCE
